<template>
  <div class="cooperation-my-contract-change-cp-container">
    <div class="contract-text-container" @click="handDetail">
      <div class="contract-title-banner">
        <span class="left-title">{{ item.pactName }}</span>
        <span
          class="right-icon"
          :class="
            item.jsstate && item.jsstate.trim() == '结算'
              ? 'text-icon-gray'
              : 'text-icon-gold'
          "
          >{{ item.jsstate }}</span
        >
      </div>
      <div class="contract-text-content">
        <span>所属项目：</span>
        <span>{{ item.projname }}</span>
      </div>
      <div class="contract-text-content">
        <span>签约日期：</span>
        <span>{{
          item.signDate && moment(item.signDate).format('YYYY-MM-DD')
        }}</span>
      </div>
      <div class="contract-text-content">
        <span>所属公司：</span>
        <span>{{ item.theirCompany }}</span>
      </div>
      <div class="contract-text-content">
        <span>合同编号：</span>
        <span>{{ item.contractcode }}</span>
      </div>
    </div>
    <div class="contract-body-box">
      <div class="contract-body-content">
        <div class="box-item">
          <p>{{ item.htamountzBz | money2 }}</p>
          <p>有效签约总额</p>
        </div>
        <div class="box-item">
          <p>{{ item.adYdyjconfirmAmount | money2 }}</p>
          <p>累计一单一结确认金额</p>
        </div>
        <div class="box-item">
          <p
            :style="{ color: item.jsstate == '已结算' ? '#36C490' : '#D7A77E' }"
          >
            {{ item.balanceSum | money2 }}
          </p>
          <p>结算金额</p>
        </div>
      </div>
    </div>
    <contract-agreement-cp
      :mainContract="item.pactName"
      :mainContractGuid="item.contractguid"
      :data="repairContracts"
      :total="item.repairContracts.length"
      @handMore="handMore"
      v-if="showContractAgreement && item.repairContracts.length"
    ></contract-agreement-cp>
  </div>
</template>

<script>
import moment from 'moment';
import contractAgreementCp from './cooperation-contract-agreement-cp';
import { getUrlParams } from 'common/js/mUtils';

export default {
  name: 'cooperation-my-contract-change-cp',

  data() {
    return {
      isAudit: true,
      testData: [1, 2, 3],
      moment,
      repairContracts: []
    };
  },
  mounted() {},
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    showContractAgreement: {
      type: Boolean,
      default: true
    },
    mainContract: {
      type: String,
      default: ''
    }
  },
  created() {
    let { item } = this;
    let { repairContracts } = JSON.parse(JSON.stringify(item));
    this.repairContracts =
      repairContracts.length > 3
        ? repairContracts.splice(0, 3)
        : repairContracts;
  },
  components: {
    contractAgreementCp
  },

  methods: {
    handDetail() {
      let { item, showContractAgreement } = this;
      let { employeeName, mobile } = getUrlParams();
      let { contractguid } = item;
      let path = showContractAgreement
        ? 'cooperationDetail'
        : 'cooperationAgreementDetail';
      // return
      this.$router.push({
        name: path,
        query: {
          contractguid,
          index: 0,
          // mainContract: item.pactName,
          mainContract: this.mainContract,
          mainContractGuid: item.contractguid,
          employeeName: decodeURIComponent(employeeName),
          mobile
        }
      });
    },
    handMore() {
      let { item } = this;
      let { contractguid, pactName } = item;
      let { employeeName, mobile } = getUrlParams();
      this.$router.push({
        name: 'contractAgreement',
        query: {
          contractguid,
          index: 0,
          mainContract: pactName,
          employeeName: decodeURIComponent(employeeName),
          mobile
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.cooperation-my-contract-change-cp-container {
  .contract-body-box {
    padding: 20px;
    .contract-body-content {
      height: 132px;
      background: rgba(239, 239, 239, 0.38);
      width: 100%;
      display: flex;
      font-size: 24px;
      .box-item {
        width: 30%;
        padding-top: 40px;
        text-align: center;
        position: relative;
        p:nth-child(1) {
          font-size: 32px;
          font-weight: bold;
        }
        p:nth-child(2) {
          margin-top: 10px;
          color: #666666;
        }
      }
      .box-item:nth-child(2) {
        width: 40%;
      }
      .box-item:nth-child(3) {
        p:nth-child(1) {
          border-right: none;
        }
      }
      .box-item::after {
        position: absolute;
        content: '';
        border: 1px solid #f1f1f1;
        height: 52px;
        transform: scaleX(0.5);
        right: 0px;
        top: 50%;
        margin-top: -26px;
      }
    }
  }

  .contract-text-container {
    padding: 20px;
    position: relative;
    .contract-title-banner {
      // position: relative;
      .left-title {
        width: 83%;
        color: #000000;
        font-size: 32px;
        display: inline-block;
        line-height: 1.5;
      }
    }
    .contract-text-content {
      color: #666666;
      font-size: 26px;
      margin-top: 10px;
      display: flex;
      // align-items: center;
      span:nth-child(1) {
        width: 140px;
        display: inline-block;
        line-height: 1.5;
        color: #999;
      }
      span:nth-child(2) {
        // overflow: hidden;
        // white-space: nowrap;
        // text-overflow: ellipsis;
        max-width: 100%;
        flex: 1;
        line-height: 1.5;
        color: #666666;
      }
    }
    .text-icon-gold {
      width: 105px;
      height: 40px;
      display: inline-block;
      background: url('../../../common/images/visa-change/gold-icon.png')
        no-repeat center;
      background-size: 100% 100%;
      text-align: center;
      padding-left: 10px;
      color: white;
      line-height: 40px;
      font-size: 22px;
      position: absolute;
      right: 0;
      top: 30px;
    }
    .text-icon-gray {
      width: 105px;
      height: 40px;
      display: inline-block;
      background: url('../../../common/images/visa-change/gray-icon.png')
        no-repeat center;
      background-size: 100% 100%;
      text-align: center;
      padding-left: 10px;
      color: white;
      line-height: 40px;
      font-size: 22px;
      position: absolute;
      right: 0;
      top: 30px;
    }
  }
}
</style>
<style lang="scss">
.cooperation-my-contract-change-cp-container {
}
</style>
